import { useEffect, useRef } from 'react'

import { HeatmapLayer } from '@deck.gl/aggregation-layers'
import { GoogleMapsOverlay } from '@deck.gl/google-maps'
import { useGoogleMap } from '@react-google-maps/api'

interface LatLng {
  lat: number
  lng: number
}

interface MapHeatmapLayerProps {
  id: string
  points: LatLng[]
  radius?: number
  intensity?: number
  threshold?: number
}

export const MapHeatmapLayer = ({
  id,
  points,
  radius = 40,
  intensity = 2,
  threshold = 0.05,
}: MapHeatmapLayerProps) => {
  const map = useGoogleMap()
  const overlayRef = useRef<GoogleMapsOverlay | null>(null)

  useEffect(() => {
    if (!map) return

    const overlay = new GoogleMapsOverlay({ layers: [] })
    overlay.setMap(map)
    overlayRef.current = overlay

    return () => {
      overlay.finalize()
      overlayRef.current = null
    }
  }, [map])

  useEffect(() => {
    if (!overlayRef.current) return

    overlayRef.current.setProps({
      layers: points.length
        ? [
            new HeatmapLayer({
              id,
              data: points,
              getPosition: (d: LatLng) => [d.lng, d.lat] as [number, number],
              radiusPixels: radius,
              intensity,
              threshold,
            }),
          ]
        : [],
    })
  }, [id, intensity, points, radius, threshold])

  return null
}
